import { render, staticRenderFns } from "./AddGrid.vue?vue&type=template&id=036be5a3&"
import script from "./AddGrid.vue?vue&type=script&lang=js&"
export * from "./AddGrid.vue?vue&type=script&lang=js&"
import style0 from "./AddGrid.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AddGrid.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports